module.exports = __webpack_public_path__ + "media/images/flags/mx-40fc809f59778931cdd1fce2b97ccfa9.svg";